export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',

  // 1. 控制台
  'menu.dashboard': '控制台',
  'menu.dashboard.workplace': '工作台',

  // 2. 应用中心
  'menu.app': '应用中心',
  'menu.app.mine': '我的应用',
  'menu.app.appName': '应用',
  'menu.app.mgmt': '应用管理',
  'menu.app.mgmt.list': '应用列表',
  'menu.app.mgmt.create': '新建应用',
  'menu.app.mgmt.edit': '编辑应用',
  'menu.app.mgmt.detail': '应用详情',
  'menu.app.mgmt.analysis': '综合数据',
  'menu.app.mgmt.appName': '应用',
  'menu.app.next-chat': '聊天',
  'menu.app.next-search': '搜索',
  'menu.app.agent': '智能体',
  'menu.app.memory': '记忆',

  // 3. 数据管理
  'menu.data': '数据管理',
  'menu.datasets': '知识库管理',
  'menu.data.dataset': '知识库管理',
  'menu.data.dataset.create': '新建知识库',
  'menu.data.dataset.edit': '编辑知识库',
  'menu.data.dataset.detail': '知识库内容管理',
  'menu.data.dataset.detail.file': '文件预览',
  'menu.data.file': '文件管理',
  'menu.data.file.content': '文件内容管理',
  'menu.file.preview': '文件预览',

  // 4. 统计分析
  'menu.analysis': '统计分析',
  'menu.analysis.access': '访问报表',
  'menu.analysis.access.login': '系统访问报表',
  'menu.analysis.access.action': '菜单操作报表',
  'menu.analysis.access.app': '应用访问统计',
  'menu.analysis.access.app-detail': '应用访问详情',
  'menu.analysis.access.user-login-detail': '用户登录详情',
  'menu.analysis.audit': '权限审计',
  'menu.analysis.audit.user': '用户权限报表',
  'menu.analysis.audit.role-assign': '角色授权报表',
  'menu.analysis.audit.role-detail': '角色权限详情',
  'menu.analysis.audit.app': '应用访问权限报表',
  'menu.analysis.audit.user-permission-detail': '用户权限详情',

  // 5. 组织管理
  'menu.org': '组织管理',
  'menu.org.user': '用户管理',
  'menu.org.user.permission': '用户权限管理',
  'menu.org.user.add': '用户新增',
  'menu.org.user.batchImportUser': '批量导入用户',
  'menu.org.user.edit': '用户编辑',
  'menu.org.user.detail': '用户详情',
  'menu.org.role': '角色管理',
  'menu.org.role.add': '角色新增',
  'menu.org.role.edit': '角色编辑',
  'menu.org.role.copy': '复制角色',
  'menu.org.company': '公司管理',
  'menu.org.company.create': '新建公司',
  'menu.org.company.edit': '编辑公司',
  'menu.org.company.setting': '公司设置',
  'menu.org.dept': '部门管理',
  'menu.org.dept.create': '新建部门',
  'menu.org.dept.edit': '编辑部门',

  // 6. 系统设置
  'menu.system': '系统设置',
  'menu.system.menu': '菜单配置',
  'menu.system.app-config': '应用配置',
  'menu.system.data-source': '数据源',
  'menu.system.config': '全局配置',
  'menu.system.license': '授权管理',
  'menu.system.changelog': '更新日志',
  'menu.system.info': '应用信息',

  // 其他
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.exception': '异常页',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.403': '403',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',

  // ─── 非导航操作埋点（状态切换 / 表单提交 / 批量操作）───
  'menu.org.company.create.submit': '新建公司-提交',
  'menu.org.company.edit.submit': '编辑公司-提交',
  'menu.org.company.enable': '启用公司',
  'menu.org.company.disable': '禁用公司',
  'menu.org.company.export': '公司管理-导出',
  'menu.org.dept.create.submit': '新建部门-提交',
  'menu.org.dept.edit.submit': '编辑部门-提交',
  'menu.org.dept.export': '部门管理-导出',
  'menu.org.role.add.submit': '新建角色-提交',
  'menu.org.role.edit.submit': '编辑角色-提交',
  'menu.org.role.copy.submit': '复制角色-提交',
  'menu.org.role.enable': '启用角色',
  'menu.org.role.disable': '禁用角色',
  'menu.org.role.batch_enable': '批量启用角色',
  'menu.org.role.batch_disable': '批量禁用角色',
  'menu.org.role.export': '角色管理-导出',
  'menu.org.user.add.submit': '新建用户-提交',
  'menu.org.user.edit.submit': '编辑用户-提交',
  'menu.org.user.enable': '启用用户',
  'menu.org.user.disable': '禁用用户',
  'menu.org.user.copy': '复制用户',
  'menu.org.user.resetPassword': '重置密码',
  'menu.org.user.permission.manager.set': '用户权限管理-设为管理员',
  'menu.org.user.permission.manager.cancel': '用户权限管理-取消管理员',
  'menu.org.user.permission.resetPassword': '用户权限管理-重置密码',
  'menu.org.user.permission.role.add': '用户权限管理-添加角色',
  'menu.org.user.permission.role.add.submit': '用户权限管理-添加角色-提交',
  'menu.org.user.permission.role.remove': '用户权限管理-移除角色',
  'menu.org.user.permission.reference': '用户权限管理-引用权限',
  'menu.org.user.permission.reference.submit': '用户权限管理-引用权限-提交',
  'menu.org.user.permission.customize.submit': '用户权限管理-提交自定义权限',
  'menu.org.user.permission.restore': '用户权限管理-恢复默认权限',
  'menu.org.user.export': '用户管理-导出',
  'menu.org.user.print': '用户管理-打印',
  'menu.org.role.print': '角色管理-打印',
  'menu.org.company.print': '公司管理-打印',
  'menu.org.dept.print': '部门管理-打印',
  'menu.analysis.access.action.export': '菜单操作报表-导出',
  'menu.analysis.access.action.print': '菜单操作报表-打印',
  'menu.analysis.access.login.export': '系统访问报表-导出',
  'menu.analysis.access.login.print': '系统访问报表-打印',
  'menu.analysis.access.app.export': '应用访问统计-导出',
  'menu.analysis.access.app.print': '应用访问统计-打印',
  'menu.analysis.access.app-detail.export': '应用访问详情-导出',
  'menu.analysis.access.app-detail.print': '应用访问详情-打印',
  'menu.analysis.audit.user.export': '用户权限报表-导出',
  'menu.analysis.audit.user.print': '用户权限报表-打印',
  'menu.analysis.audit.role-assign.export': '角色授权报表-导出',
  'menu.analysis.audit.role-assign.print': '角色授权报表-打印',
  'menu.analysis.audit.role-detail.export': '角色权限详情-导出',
  'menu.analysis.audit.role-detail.print': '角色权限详情-打印',
  'menu.analysis.audit.app.export': '应用访问权限报表-导出',
  'menu.analysis.audit.app.print': '应用访问权限报表-打印',
  'menu.system.menu.edit.submit': '菜单配置-编辑提交',
  'menu.system.menu.drag.submit': '菜单配置-拖拽排序',
  'menu.app.mgmt.list.add': '新建应用',
  'menu.app.mgmt.list.edit': '编辑应用',
  'menu.app.mgmt.list.config': '配置应用',
  'menu.app.mgmt.list.enable': '启用应用',
  'menu.app.mgmt.list.disable': '停用应用',
  'menu.app.mgmt.list.export': '应用管理-导出',
  'menu.app.mgmt.list.print': '应用管理-打印',
};
